export default "__VITE_ASSET__C_28AGty__"